import { useMutation, useQueryClient } from 'react-query';
import LanguageService from '../../../shared/LanguageService';
import TranslationsApi from './TranslationsApi';
import { TranslationDto, UpdateTranslationInput } from '../types';
import { translationQueryKey } from './queryKeys';

export interface UpdateTranslationArgs {
    key: string;
    input: UpdateTranslationInput;
}

function applyToLoadedDictionary(saved: TranslationDto) {
    const loadedLanguage = LanguageService.getLanguage();
    if (!loadedLanguage) {
        return;
    }

    const translation = saved.translations[loadedLanguage.key];
    if (typeof translation === 'string') {
        LanguageService.updateTranslation(saved.key, translation);
    }
}

export function useUpdateTranslationMutation() {
    const queryClient = useQueryClient();

    return useMutation<TranslationDto, unknown, UpdateTranslationArgs>(
        ({ key, input }) => TranslationsApi.update(key, input),
        {
            onSuccess: (saved: TranslationDto) => {
                queryClient.setQueryData([translationQueryKey, saved.key], saved);
                applyToLoadedDictionary(saved);
            }
        }
    );
}
